/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { Link, useNavigate, Route, Routes, useLocation } from 'react-router-dom';
import Login from './Login/Login';
import SignUp from './SignUp/SignUp';
import DashBoard from './Home/dashboard';
import Project from './Home/Project/project';
import Catalog from './Home/Catalog/catalog';
import Templates from './Home/Templates/templates';
import ChangePassword from './Home/ChangePassword/ChangePassword';
import MyProfile from './Home/MyProfile/MyProfile';
import User from './Home/Admin/user';
import ProductDetails from './Home/Catalog/ProductDetails';
import CreateProduct from './Home/Catalog/CreateProduct';
import PersonIcon from '@mui/icons-material/Person';
import { Avatar, Menu, useMediaQuery, useTheme, Drawer, Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip } from '@mui/material';
import CreateProject from './Home/Project/CreateProject';
import { Menus } from '../common/const';
import MenuIcon from '@mui/icons-material/Menu';
import PrivateRoute from './PrivateRoute';
import { useDispatch, useSelector } from 'react-redux';
import { getUserByToken, setSession, userSignOut } from '../redux/Actions/userActions';
import TechnicalForm from './TechnicalForm';

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
    background: 'white',
    color: 'black',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
        {
            props: ({ open }) => open,
            style: {
                marginLeft: drawerWidth,
                width: `calc(100% - ${drawerWidth}px)`,
                transition: theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
    ],
}));

export default function Layout() {
    const token = localStorage.getItem('token');
    const { isAuthenticated, user, roles } = useSelector((state) => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const currentPlanId = user?.organization?.Subscriptions[0]?.plan_id;
    const dispatch = useDispatch();
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const [profileMenu, setProfileMenu] = React.useState(null);
    const [isSignOut, setSignOut] = React.useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check for mobile devices

    const handleDrawerOpen = () => {
        setOpenDrawer(true);
    };

    const handleDrawerClose = () => {
        setOpenDrawer(false);
    };
    const showSidebar = location.pathname !== '/' && location.pathname !== '/sign-up' && !location.pathname.includes('ts-form') && isAuthenticated && location.pathname !== '/app/change-password';

    useEffect(() => {
        if (user && Object.keys(user).length > 0) {
            if (user?.password_updated_at) {
                const lastVisitedPath = localStorage.getItem('lastVisitedPath');
                const targetPath = lastVisitedPath || '/app/home/dashboard';

                if (location.pathname === '/' && !sessionStorage.getItem('reloaded')) {
                    sessionStorage.setItem('reloaded', 'true');  // set flag BEFORE reload
                    window.location.href = targetPath;
                } else {
                    navigate(targetPath);
                }
            } else {
                navigate('/app/change-password');
            }
        }
    }, [user]);

    useEffect(() => {
        if (isAuthenticated && location.pathname !== '/' && !location.pathname.includes('ts-form')) {
            localStorage.setItem('lastVisitedPath', location.pathname);
        }
    }, [location.pathname, isAuthenticated]);

    useEffect(() => {
        if (token) {
            dispatch(getUserByToken());
            dispatch(setSession(token));
        }
    }, [token]);

    return (
        <Box sx={{ display: 'flex' }}>
            <Dialog
                open={isSignOut}
                maxWidth="sm"
            >
                <DialogTitle>Are you sure to Sign out?</DialogTitle>
                <DialogContent>
                    You will be logged out from App!
                </DialogContent>
                <DialogActions>
                    <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        onClick={() => {
                            dispatch(userSignOut());
                            navigate('/');
                            setSignOut(false);
                        }}
                    >
                        Agree
                    </Button>
                    <Button
                        color="secondary"
                        variant="contained"
                        size="small"
                        onClick={() => setSignOut(false)}
                    >
                        Disagree
                    </Button>
                </DialogActions>
            </Dialog>
            <CssBaseline />
            {showSidebar && (
                <>
                    <AppBar position="fixed" sx={{ zIndex: 1201 }}>
                        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            {/* Logo */}
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {isMobile && (
                                    <IconButton color="inherit" edge="start" onClick={handleDrawerOpen}>
                                        <MenuIcon />
                                    </IconButton>
                                )}
                                <img src="/images/Logo.png" alt='logo' style={{ height: 50, cursor: 'pointer' }} onClick={() => navigate('/app/home/dashboard')} />
                            </Box>

                            {/* Menu Items (Desktop) */}
                            {!isMobile && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                    {Menus.filter((a) => isUser?.code === 'orgGuestUser' ? !['Catalog', 'Templates', 'Admin'].includes(a.label) : currentPlanId === 7 ? !['Projects', 'Templates'].includes(a.label) : a.label).map((menu) => (
                                        <Link
                                            to={menu.path}
                                            key={menu.label}
                                            style={{
                                                textDecoration: 'none',
                                                fontSize: 16,
                                                padding: '8px 16px',
                                                borderRadius: 5,
                                                color: location.pathname.includes(menu.path) ? 'white' : 'black',
                                                backgroundColor: location.pathname.includes(menu.path) ? '#3f51b5' : 'transparent',
                                                transition: 'background-color 0.3s ease',
                                            }}
                                        >
                                            {menu.label}
                                        </Link>
                                    ))}
                                </Box>
                            )}

                            {/* Profile Menu */}
                            <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={(e) => setProfileMenu(e.currentTarget)}>
                                <Tooltip title={user?.organization?.org_name}>
                                    <IconButton color="inherit">
                                        <Avatar alt="Profile" sx={{ fontSize: 18, color: '#005eb2', fontWeight: 'bold' }}>
                                            {`${user?.first_name?.charAt(0) ? user?.first_name?.charAt(0) : ''}${user?.last_name?.charAt(0) ? user?.last_name?.charAt(0) : ''}`}
                                        </Avatar>
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Toolbar>

                        {/* Profile Menu Popup */}
                        <Menu
                            id="profile-menu"
                            open={Boolean(profileMenu)}
                            anchorEl={profileMenu}
                            onClose={() => setProfileMenu(null)}
                            sx={{ marginTop: 1 }}
                            PaperProps={{
                                sx: {
                                    backgroundColor: 'background.paper',
                                    borderRadius: '8px',
                                    boxShadow: 3,
                                    minWidth: '265px',
                                },
                            }}
                        >
                            <div
                                style={{ padding: 10, display: 'flex', gap: 10, alignItems: 'center', cursor: 'pointer' }}
                                onClick={() => {
                                    navigate('/app/my-profile');
                                    setProfileMenu(null);
                                }}
                            >
                                <PersonIcon color="primary" />
                                <Typography>
                                    Profile
                                </Typography>
                            </div>
                            <div style={{ padding: 10 }}>
                                <Typography
                                    sx={{
                                        fontSize: 16,
                                        fontWeight: 'bold',
                                        textDecoration: 'none',
                                        '&:hover': {
                                            cursor: 'pointer',
                                            color: 'primary.main',
                                        },
                                    }}
                                    color="primary"
                                    onClick={() => {
                                        setSignOut(true);
                                        setProfileMenu(null);
                                    }}
                                >
                                    Sign Out
                                </Typography>
                            </div>
                        </Menu>
                        <Drawer anchor="left" open={openDrawer} onClose={handleDrawerClose}>
                            <Box sx={{ width: 250, padding: 2, marginTop: '50px !important' }}>
                                {Menus.filter((a) => isUser?.code === 'orgGuestUser' ? !['Catalog', 'Templates', 'Admin'].includes(a.label) : currentPlanId === 7 ? !['Projects', 'Templates'].includes(a.label) : a.label).map((menu) => (
                                    <Link
                                        to={menu.path}
                                        key={menu.label}
                                        style={{
                                            textDecoration: 'none',
                                            fontSize: 18,
                                            padding: location.pathname.includes(menu.path) ? '12px' : '12px 0px',
                                            display: 'block',
                                            borderRadius: 5,
                                            color: location.pathname.includes(menu.path) ? 'white' : 'black',
                                            backgroundColor: location.pathname.includes(menu.path) ? '#3f51b5' : 'transparent',
                                            transition: 'background-color 0.3s ease',
                                        }}
                                        onClick={handleDrawerClose}
                                    >
                                        {menu.label}
                                    </Link>
                                ))}
                            </Box>
                        </Drawer>
                    </AppBar>
                </>
            )}
            <Box sx={{ flexGrow: 1 }}>
                <Routes>
                    <Route exact path="/" element={<Login />} />
                    <Route path="/sign-up" element={<SignUp />} />
                    <Route path="/app/home/dashboard" element={<PrivateRoute><DashBoard /></PrivateRoute>} />
                    <Route path="/app/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
                    <Route path='/reset-password' element={<ChangePassword />} />
                    <Route path="/app/catalog" element={<PrivateRoute><Catalog fromTemplate={false} /></PrivateRoute>} />
                    <Route path="/app/projects" element={<PrivateRoute><Project /></PrivateRoute>} />
                    <Route path="/app/templates" element={<PrivateRoute><Templates /></PrivateRoute>} />
                    <Route path="/app/user" element={<PrivateRoute><User /></PrivateRoute>} />
                    <Route path="/app/projects/create" element={<PrivateRoute><CreateProject /></PrivateRoute>} />
                    <Route path="/app/my-profile" element={<PrivateRoute><MyProfile /></PrivateRoute>} />
                    <Route path="/app/catalog/product/:from/:id" element={<PrivateRoute><ProductDetails /></PrivateRoute>} />
                    <Route path="/app/catalog/create-product" element={<PrivateRoute><CreateProduct /></PrivateRoute>} />
                    <Route path="/ts-form/:formid/:contactid" element={<TechnicalForm />} />
                </Routes>
            </Box>
        </Box>
    );
}